import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { isValidLogin } from '_core/helpers/validations';
import { IDocs } from '_core/types';
import { maskedContactApi as API } from '../Apis';

export const MaskedContactDocs: IDocs = {
  title: 'MaskedContact',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.maskedContact',
};

const prepareCall = (stateRequestParameters: any) => {
  const login = isValidLogin(stateRequestParameters.login);
  return API.call.post(
    login.type === 'EMAIL'
      ? {
          email: stateRequestParameters.login.toLowerCase(),
        }
      : login.type === 'MEMBER'
      ? { memberNumber: stateRequestParameters.login }
      : { document: { type: 'CPF', value: stateRequestParameters.login } },
  );
};

const handleSucessFinalResponseFunction = (data: any) => {
  const dataResponse = data;
  if (dataResponse?.phoneNumber && dataResponse?.phoneNumber.length <= 4)
    dataResponse.phoneNumber = null;
  return dataResponse;
};

export const MaskedContactMachine = GenericMachine(
  prepareCall,
  {
    docs: MaskedContactDocs,
    definitions: API.definitions,
  },
  {
    handleSucessFinalResponseFunction,
  },
);
